// Centralized storage cache keys used across the app.

export const CACHE_KEYS = {
  // Generic NGRX cache namespaces
  ngrxCache: 'NgrxCache',
  ngrxCacheSchedules: 'NgrxCache-schedules-by-location',
  ngrxCacheAwaitingFirstSlots: 'NgrxCache-awaitingFirstSlots-by-location',
  ngrxCacheAwaitingFollowUpSlots: 'NgrxCache-awaitingFollowUpSlots-by-location',
  ngrxCacheSelectedProductTypesAtLocation: 'NgrxCache-selectedProductTypes-by-location',

  // Entity collection cache entries
  businessEntities: 'businessEntities',
  businessServices: 'businessServices',
  locations: 'locations',
  productTypes: 'productTypes',
  regions: 'regions',
  roles: 'roles',
  subjects: 'subjects',
  declineReasons: 'declineReasons',
  activeCalendarDate: 'activeCalendarDate',

  // User-specific/current selection cache keys
  activeLocationGlobal: 'active-location-global',
} as const;

// Prefixes for dynamic keys
export const CACHE_KEY_PREFIX = {
  activeLocationForUser: 'active-location-for-user-',
  candidateHasLocationsForUser: 'candidate-has-locations-for-user-',
  weeklySchedulesFiltersForUser: 'weekly-schedules-filters-for-user-',
} as const;
